module.exports = __webpack_public_path__ + "img/stamp-fish-spring.42170a5e.png";